module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAMAAADyQNAxAAAAaVBMVEUAAAA4w1A4w1A5xFA4w1A4w1Awv045w1E4xFA4xFE4w1EsrzM4xE84w1A4xFA4xFA3w1A3xE8yv0ssvUIpnSk4xFA3w1E4w1A4xE84w1A4w1A3wk43wk8wvkY4w1A4w1A4xFA5wlA5xFELp5NvAAAAInRSTlMAybLYzMMP69ubrgdf5c+tkIkfCwTwpJyVfWxCKxfetrU2VElHpwAAAJxJREFUOMvt07kSgkAQhOFmgQXZBbmRy6Pf/yElsKwNcDbQgMAv/qsmmcZx2T6WZJMB2gt9lIYluyISJOQIxe4BSX1lhIABZGemP6uyd2X0vsat5jTZl1unKvnJ3anqajjtGcrFqQT/6ovKGNP6qjkIN1UrV6+FaLlaerWx8kX/R9+Y15DoggUmMleSlCzRKPpEK9CMcSgJqhVH9QQbiB2eB7hgAwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/card-icon.png
// module id = 527
// module chunks = 0